import InstitutionContent from "./institution-content";

export default InstitutionContent;
